import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { listDunningStages } from '../../../../services/finance/dunningApi';
import { financeErrorMessage } from '../../utils/apiError';

// ---------------------------------------------------------------------------
// Raias do kanban. Fetch único no mount + refetch sob demanda (o modal de
// gestão chama os services de mutação e pede refetch). Colunas SEMPRE
// ordenadas por `position`, só ativas.
// ---------------------------------------------------------------------------

export default function useStages() {
   const [stages, setStages] = useState([]);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   const seqRef = useRef(0);

   const fetchStages = useCallback(async ({ quiet = false } = {}) => {
      seqRef.current += 1;
      const seq = seqRef.current;

      if (!quiet) {
         setLoading(true);
         setError(null);
      }

      try {
         const result = await listDunningStages();
         if (seqRef.current !== seq) return;
         setStages(result);
         setLoading(false);
         setError(null);
      } catch (err) {
         if (seqRef.current !== seq) return;
         setLoading(false);
         if (!quiet) {
            setError(err);
            toast.error(
               financeErrorMessage(err, 'Falha ao carregar as raias.')
            );
         }
      }
   }, []);

   useEffect(() => {
      fetchStages();
   }, [fetchStages]);

   const activeStages = useMemo(
      () =>
         stages
            .filter((stage) => stage.is_active)
            .sort((a, b) => a.position - b.position),
      [stages]
   );

   return { stages, activeStages, loading, error, refetch: fetchStages };
}
